module.exports = __webpack_public_path__ + "img/installation-7.8f4c070f.png";